import React from 'react';

const Library = () => {
  return (
    <div>
      Library
      Library
    </div>
  );
}

export default Library;
